<template>
  <div class="container" :style="{ 'background-image': `url(${require('@/assets/bg_yh.jpg')})` }">
    <div class="top-box">
      <img class="top-img" src="../assets/top_img.png" />
      <div class="top-info">
        <div class="top-left">
          <img src="../assets/logo.png" />
          <div>数字展览可视化管理系统</div>
        </div>
        <div class="top-title" :title="data.title">{{ data.title }}</div>
        <div class="top-right">
          <div class="time">{{ time }}</div>
          <div class="date">
            <div>
              {{ date }}
            </div>
            <div>
              {{ week }}
            </div>
          </div>
          <div class="logout" @click="logout">注销</div>
        </div>
      </div>
      <div class="top-desc">展览时间：{{data.startDate}}至{{ data.endDate }}</div>
    </div>
    <div class="left-top-data data-box">
      <div class="bottom-header data-header">
        展览主题
        <span>Exhibition theme</span>
        <a target="_blank" :href="'https://glr.yslt.art/pc.html?onSharePage=1&galleryId='+data.galleryId" class="desc">进入展览 >></a>
      </div>
      <div class="detail-info">
        <img :src="data.galleryHead" />
        <div>{{ data.description }}</div>
      </div>
    </div>
    <div class="left-bottom-data data-box">
      <div class="bottom-header data-header">参展艺术家<span>Exhibition theme</span></div>
      <div class="user-list">
        <div class="user-item" v-for="(item, index) in data.userLists">
          <img :src="item.avatar" />
          <div class="name">{{ item.nickname }}</div>
          <div class="count">参展：{{ item.count1 }}幅</div>
        </div>
      </div>
    </div>
    <div class="right-top-data data-box">
      <div class="bottom-header data-header">参展作品<span>Participating Artists</span></div>
      <div class="works-list">
        <div class="works-item" v-for="(item, index) in worksLists">
          <img :src="item.coverUrl" />
          <div class="title" :title="item.title">{{ item.title }}</div>
          <div class="desc">{{ item.labels }}/{{ item.nickname }}作品</div>
        </div>
      </div>
    </div>
    <div class="bottom-box">
      <img class="bottom-img" src="../assets/bottom_img.png" />
      <div class="bottom-menu-box">
        <div class="bottom-menu">
          <div class="menu-item">
            <router-link :to="{ name: 'UserData' }">
              <img src="../assets/menu_yh_off.png" />
              <div>运营数据</div>
            </router-link>
          </div>
          <div class="menu-item active">
            <img src="../assets/menu_yy_on.png" />
            <div>展览数据</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import md5 from 'js-md5'
import https from '../https.js'
export default {
  name: 'OperateData',
  components: {
  },
  data() {
    return {
      data: [],
      time: "",
      date: "",
      week: "",
      timer: '',
      worksLists: [],
    }
  },
  mounted() {
    this.getInfo()
    this.timer = setInterval(() => {
      this.getInfo()
    }, 60000);
    this.getTime()
    setInterval(() => {
      this.getTime()
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = ''
  },
  methods: {
    getInfo() {
      let name = sessionStorage.getItem(md5("yslt_account")) || localStorage.getItem(md5("yslt_account"))
      let password = sessionStorage.getItem(md5("yslt_password")) || localStorage.getItem(md5("yslt_password"))
      let params = {
        'account': name,
        'password': password
      }
      https.fetchPost('/api/v1/appGallery/detail', params).then((data) => {
        if (data.code == 0) {
          this.data = data.result
          let result = data.result

          this.worksLists = result.worksLists
        }else {
          this.logout()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    logout() {
      sessionStorage.removeItem(md5("yslt_account"))
      sessionStorage.removeItem(md5("yslt_password"))
      localStorage.removeItem(md5("yslt_password"))
      this.$router.push('/Login')
    },
    getTime() {
      const date = new Date()
      const hours = date.getHours()
      let minutes = date.getMinutes()
      if (minutes < 10) {
        minutes = "0" + minutes
      }
      let seconds = date.getSeconds()
      if (seconds < 10) {
        seconds = "0" + seconds
      }
      this.time = `${hours}:${minutes}:${seconds}`
      const month = date.getMonth() + 1
      const day = date.getDate()
      this.date = `${month}月${day}日`
      const weekDay = date.getDay()
      const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      this.week = weekDays[weekDay]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.container {
  min-height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
}

.top-box {
  max-width: 1920px;
  min-width: 1024px;
  height: 1.575rem
    /* 126/80 */
  ;
  position: relative;

  .top-img {
    width: 100%;
    height: 1.575rem
      /* 126/80 */
    ;
    object-fit: fill;
  }

  .top-info {
    position: absolute;
    top: .225rem
      /* 18/80 */
    ;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 .475rem
      /* 38/80 */
      0 .375rem
      /* 30/80 */
    ;

    .top-left,
    .top-right {
      width: auto;
      cursor: default;
    }

    .top-left {
      display: flex;
      align-items: center;

      >img {
        height: .5rem
          /* 40/80 */
        ;
        width: .5rem
          /* 40/80 */
        ;
        margin-right: .2125rem
          /* 17/80 */
        ;
      }

      >div {
        font-size: .3rem
          /* 24/80 */
        ;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #fff;
        line-height: 1;
      }
    }

    .top-title {
      font-family: 'siyuan';
      font-size: .425rem
        /* 34/80 */
      ;
      font-weight: 800;
      color: #FFFFFF;
      line-height: 1;
      max-width: 8.75rem;
      overflow: hidden;
      /* 溢出部分进行隐藏 */
      display: -webkit-box;
      -webkit-box-orient: vertical;
      /* 盒模型元素从顶部向底部垂直排列子元素 */
      -webkit-line-clamp: 1;
      /* 显示两行 */
      text-overflow: ellipsis;
      cursor: default;
    }

    .top-right {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .time {
        font-size: .4rem
          /* 32/80 */
        ;
        font-family: Myriad Pro;
        font-weight: 400;
        color: #fff;
        line-height: 1;
      }

      .date {
        font-size: .15rem
          /* 12/80 */
        ;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #fff;
        line-height: 1;
        margin-left: .25rem
          /* 20/80 */
        ;
        margin-right: .5875rem
          /* 47/80 */
        ;
      }

      .logout {
        font-size: .25rem;
        color: #fff;
        font-weight: 400;
        border-bottom: 1px solid #fff;
        cursor: pointer;
      }
    }
  }

  .top-desc {
    position: absolute;
    bottom: .475rem
      /* 38/80 */
    ;
    left: 0;
    width: 100%;
    font-size: .15rem
      /* 12/80 */
    ;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }
}

.left-bottom-data {
  position: fixed;
  bottom: 1.25rem;
  left: .925rem;
  width: 9.2rem;

  .user-list::-webkit-scrollbar {
      display: none;
    }

  .user-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
        overflow-x: scroll;
        margin: .375rem 0 0;
        max-height: 1.875rem;

    .user-item {
      margin-left: .5rem;
      margin-bottom: .175rem;

      >img {
        height: .95rem;
        width: .95rem;
        border-radius: 1rem;
      }

      .name {
        margin-top: .1rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: .2rem;
        color: #fff;
      }

      .count {
        margin-top: .05rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: .15rem;
        color: #9CAFBD;
      }
    }
  }
}

.left-top-data {
  position: fixed;
  top: 1.5rem;
  left: .925rem;
  width: 9.2rem;

  .detail-info {
    display: flex;
    align-items: center;
    margin: .35rem;

    >img {
      margin-right: .5rem;
      height: 3.75rem;
      width: 2.8rem;
    }

    >div::-webkit-scrollbar {
      display: none;
    }

    >div {
      width: 4.9125rem;
      height: 3.75rem;
      overflow-y: scroll;
      color: #fff;
      line-height: 1.6;
      text-align: left;
    }
  }
}

.right-top-data {
  position: fixed;
  top: 1.5rem;
  right: .925rem;
  width: 12.725rem;

  .works-list::-webkit-scrollbar {
    display: none;
  }

  .works-list {
    padding: .4625rem 0;
    display: flex;
    flex-wrap: wrap;
    max-height: 6.625rem;
    overflow-y: scroll;

    .works-item {
      margin-bottom: .25rem;
      margin-left: .5rem;

      >img {
        width: 2.5rem;
        height: 2.5rem;
        object-fit: contain;
        background-color: rgba(0,0,0,0.2);
      }

      .title {
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: .2rem;
        color: #fff;
        margin-top: .1rem;
        text-align: left;
        overflow: hidden;
        /* 溢出部分进行隐藏 */
        display: -webkit-box;
        -webkit-box-orient: vertical;
        /* 盒模型元素从顶部向底部垂直排列子元素 */
        -webkit-line-clamp: 1;
        /* 显示两行 */
        text-overflow: ellipsis;
        width: 2.5rem;
        cursor: default;
      }

      .desc {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: .15rem;
        color: #9CAFBD;
        margin-top: .05rem;
        text-align: left;
      }
    }
  }
}

.data-box {
  border: 1px solid rgba(25, 186, 139, 0.17);
  background: rgba(255, 255, 255, 0.04) url(../assets/line.png);
  padding: .25rem 0;

  .data-header {
    padding-bottom: .2rem;
    margin: 0 .4375rem;
    font-size: .2rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #fff;
    display: flex;
    align-items: flex-end;
    border-bottom: .0125rem solid rgba(116, 172, 255, 0.42);

    >span {
      margin-left: .1rem;
      font-size: .1375rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #fff;
    }
    .desc{
      flex: 1;
      text-align: right;
      color: #fff;
    }
  }

  .content-header {
    padding: .2rem 0 0 .3375rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fff;
    font-size: .175rem;
    text-align: left;
    display: flex;
    align-items: center;

    >img {
      height: .45rem;
      width: auto;
      margin-right: .15rem;
      opacity: 0.5;
    }
  }
}


.bottom-box {
  max-width: 1920px;
  min-width: 1024px;
  width: 100%;
  font-size: 0;
  position: fixed;
  bottom: 0;
  left: 0;

  .bottom-img {
    width: 100%;
    height: .85rem
      /* 68/80 */
    ;
  }

  .bottom-menu-box {
    position: absolute;
    width: 100%;
    bottom: .1375rem
      /* 11/80 */
    ;
    left: 0;

    .bottom-menu {
      margin: 0 auto;
      width: 4.3rem
        /* 344/80 */
      ;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .menu-item {
        position: relative;
        width: 1.25rem
          /* 100/80 */
        ;

        a {
          text-decoration: none;
          display: block;
        }

        img {
          height: .5rem
            /* 40/80 */
          ;
          width: .5rem
            /* 40/80 */
          ;
        }

        div {
          margin-top: .0875rem
            /* 7/80 */
          ;
          font-size: .2rem
            /* 16/80 */
          ;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #506676;
          margin-top: .0875rem
            /* 7/80 */
          ;
          opacity: 0.7;
        }
      }

      .active {
        >img {
          position: absolute;
          left: 0;
          bottom: .1rem
            /* 8/80 */
          ;
          height: 1.25rem
            /* 100/80 */
            !important;
          width: 1.25rem
            /* 100/80 */
            !important;
        }

        >div {
          font-weight: bold !important;
          color: rgb(0, 18, 79) !important;
        }
      }
    }
  }
}</style>



// WEBPACK FOOTER //
// src/components/OperateData.vue